export default "__VITE_ASSET__49187072__"